import { lazy } from 'react'

export const AuthSetNewPassword = lazy(
  () => import('features/Auth/components/AuthSetNewPassword/AuthSetNewPassword'),
)
